import { BlueprintContext } from '../blueprint-context/blueprint-context.class';

import { KitchenDesignData, KitchenDesignDataIn } from '../..';

export const kitchenDesignData = (context: BlueprintContext, dataIn: KitchenDesignDataIn = null): KitchenDesignData => {
	// const rd = new RecordData<KitchenDesignDataIn>(dataIn);

	const record: KitchenDesignData = {
		islands: dataIn?.islands ?? null,
		countertops: dataIn?.countertops ?? null,
		dimensions: dataIn?.dimensions ?? null,
		obstructions: dataIn?.obstructions ?? null,
		notifications: dataIn?.notifications ?? null
	};

	return record;
};
